const states = {
  paySign: null,
};
const mutations = {
  SET_PAYSIGN(state, data) {
    state.paySign = data;
  },
};
export default {
  states,
  mutations,
};
